/**
 * Which in-game account notice (guest / verify email) the player dismissed
 * this browser session. Keyed by uid as well as email, because guests have no
 * email, and cleared on logout so the next account in the tab starts fresh.
 */
const DISMISSED_KEY = 'kaeliux-dismissed-account-notice';

export function readDismissedAccountNotice(): string | null {
    try {
        return sessionStorage.getItem(DISMISSED_KEY);
    } catch {
        return null;
    }
}

export function writeDismissedAccountNotice(key: string): void {
    try {
        sessionStorage.setItem(DISMISSED_KEY, key);
    } catch {
        // Storage blocked: the notice is hidden until the next reload instead.
    }
}

export function clearDismissedAccountNotice(): void {
    try {
        sessionStorage.removeItem(DISMISSED_KEY);
    } catch {
        // Nothing stored that we could remove.
    }
}
